import { setPassiveTouchGestures } from "@polymer/polymer/lib/utils/settings";
// import "@webcomponents/scoped-custom-element-registry/scoped-custom-element-registry.min";
import "../layouts/taui-app";
import "../resources/roboto";
import "../resources/taui-style";
import "../util/legacy-support";

setPassiveTouchGestures(true);
